import PublishIcon from "@mui/icons-material/LanguageRounded";
import { Stack, Typography } from "@mui/material";
import type { DocumentCollectionPortalPublishStatus } from "../../../api/types/documentCollectionTypes";
import UnpublishIcon from "@entrilia/shared/icons/UnpublishIcon";

interface Props {
  portalPublishStatus: DocumentCollectionPortalPublishStatus;
}

const DocumentCollectionPortalStatusTag = ({ portalPublishStatus }: Props) => {
  switch (portalPublishStatus) {
    case "AllPublished":
      return (
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <PublishIcon color="success" />
          <Typography color="success">Published</Typography>
        </Stack>
      );
    case "PartiallyPublished":
      return (
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <PublishIcon color="warning" />
          <Typography color="warning">Partially Published</Typography>
        </Stack>
      );
    case "NonePublished":
      return (
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <UnpublishIcon color="disabled" />
          <Typography color="textDisabled">Not Published</Typography>
        </Stack>
      );
    default:
      return null;
  }
};

export default DocumentCollectionPortalStatusTag;
